module.exports = __webpack_public_path__ + "static/media/message-tick.842fbff4.png";